<template>
  <div>
    <div :class="'md-layout'">
      <div :class="'md-layout-item md-size-130'" v-if="!review.section_text">
        <div :class="'md-title'">Overall</div>
      </div>
      <br><br>
      <div :class="'md-layout-item md-size-100'">
        <div :class="'md-title'"><i>{{ review.section_text }}</i> Comments</div>
      </div>
      <div :class="'md-layout-item md-size-100'">
        <md-field>
          <label>Provide comments (if applicable)</label>
          <md-textarea md-autogrow v-model="data.comments" :disabled="isDisabled || sending" @blur.prevent="sendRating"></md-textarea>
        </md-field>
      </div>
    </div>
    <div :class="'md-layout mt-4'" v-if="section !== 'review_comments'">
      <div :class="'md-layout-item md-size-100'">
        <div :class="'md-title'"><i>{{ review.section_text }}</i> Rating</div>
      </div>
      <div :class="'md-layout-item md-size-100'">
        <md-radio @change="sendRating" v-model="data.rating" :value="1" :disabled="isDisabled || sending">
          Compliant
        </md-radio>
        <md-radio @change="sendRating" v-model="data.rating" :value="2" :disabled="isDisabled || sending">
          Adequate (some exceptions)
        </md-radio>
        <md-radio @change="sendRating" v-model="data.rating" :value="3" :disabled="isDisabled || sending">
          Unsatisfactory
        </md-radio>
      </div>

      <div :class="'md-layout mt-4'" v-if="data.rating > 1 && canApplyActionPlan">
        <div :class="'md-layout-item md-size-100'">
          <div :class="'md-title'">Action Plan</div>
        </div>
        <div :class="'md-layout-item md-size-100'">
          <md-field>
            <label>Provide the action plan</label>
            <md-textarea md-autogrow v-model="data.action_plan" :disabled="isDisabled || sending" @blur.prevent="sendRating"></md-textarea>
          </md-field>
        </div>
      </div>
    </div>
    <div :class="'md-layout mt-4'" v-if="section !== 'review_comments'">
      <div :class="'md-layout mt-4'" v-if="data.rating > 1 && canApplyActionPlan">
        <div :class="'md-layout-item md-size-100'">
          <div :class="'md-title'">Action Plan Deadline</div>
        </div>
        <div  :class="['md-layout-item md-size-100',{ 'is-disabled-wrapper': isDisabled || sending }]">
          <md-datepicker
            :class="{ 'is-disabled-input': isDisabled || sending }"
            md-immediately
            v-model="data.action_plan_deadline"
            @md-closed="sendRating">
            <label></label>
          </md-datepicker>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      review: {
        required: true,
        type: Object,
      },
      section: {
        required: true,
        type: String
      },
      rating: {
        required: true,
        type: Object
      },
      isDisabled: {
        default: false,
        type: Boolean
      },
      rqrReviewer: {
        required: false,
        type: Number
      }
    },
    data () {
      return {
        data: {
          comments: this.rating.comment,
          rating: this.rating.rating || 0,
          action_plan: this.rating.action_plan,
          action_plan_deadline: this.rating.action_plan_deadline
        },
        sending: false
      }
    },
    methods: {
      sendRating () {
        if (this.sending) return

        const id = this.$route.params.id
        const data = this.getRating()

        this.$nextTick(() => {
          try {
            data.action_plan_deadline = this.data.action_plan_deadline
              ? this.data.action_plan_deadline.toISOString().slice(0,10)
              : null
          } catch (error) {
            delete data.action_plan_deadline
          }

          this.sending = true

          this.$api.request.post(`reviews/${id}/ratings`, data)
            .then(() => {
              this.$emit('updateRating', { section: this.section, value: this.data.rating })
            })
            .catch(() => {
              this.$toast.warning('Please, try again.', '')
            })
            .finally(() => {
              this.sending = false
            })
        })

      },
      getRating () {
        return {
          section: this.section,
          rating: this.data.rating === 0 ? null : this.data.rating,
          comment: this.data.comments,
          action_plan: this.data.action_plan
        }
      }
    },
    computed: {
      canApplyActionPlan () {
        return (
          this.isAdmin ||
          this.isRqrReviewer ||
          this.profile === 'rqr_leader'
        ) && this.review.section_text
      },
      profile () {
        return this.$store.state.currentProfile
      },
      userId () {
        return this.$store.state.user.id
      },
      isAdmin () {
        return this.profile === 'admin'
      },
      isRqrReviewer () {
        return this.rqrReviewer === this.userId &&
          this.profile === 'reviewer'
      },
    }
  }
</script>

<style lang="sass">
  .is-disabled-input
    pointer-events: none

  .is-disabled-wrapper
    cursor: not-allowed
    button.md-button.md-clear
      display: none
</style>
